export default __webpack_public_path__ + "static/media/importexport1.ca46a845.png";